import { render, staticRenderFns } from "./MainBusiness.vue?vue&type=template&id=9b533c76&scoped=true&"
import script from "./MainBusiness.vue?vue&type=script&lang=js&"
export * from "./MainBusiness.vue?vue&type=script&lang=js&"
import style0 from "./MainBusiness.vue?vue&type=style&index=0&id=9b533c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b533c76",
  null
  
)

export default component.exports